module.exports = __webpack_public_path__ + "static/Henri_Crozel-d713a376a200f10b3e0abed999be6a2c.png";